import { motion } from "framer-motion";
import AnimatedBox from "../../../components/AnimatedBox";

const tools = [
  {
    id: 1,
    name: "Fivetran",
    image: "/tool-1.png",
    description:
      "Automated data integration that reliably moves data into your warehouse.",
  },
  {
    id: 2,
    name: "HVR",
    image: "/tool-2.png",
    description:
      "High-performance, real-time data replication for critical systems.",
  },
  {
    id: 3,
    name: "dbt Labs",
    image: "/tool-3.png",
    description:
      "Transform, test, and document data directly inside your warehouse.",
  },
  {
    id: 4,
    name: "Informatica",
    image: "/tool-4.jpeg",
    description:
      "Enterprise-grade cloud data management and integration at scale.",
  },
  {
    id: 5,
    name: "Airbyte",
    image: "/tool-5.png",
    description:
      "Open-source data integration platform that syncs data from applications, APIs, and databases.",
  },
];

const ToolsSection = () => {
  return (
    <>
      <div className="container mx-auto px-4 md:px-6 lg:px-8 text-center py-24">
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2
            className="text-3xl font-semibold text-center mx-auto mb-10"
            style={{ color: "var(--color-primary)" }}
          >
            Supported Tools
          </h2>
        </motion.div>

        <section className="tools-grid">
          {tools.map((tool, idx) => (
            <AnimatedBox key={tool.id} className="tool-card">
              <div className="image-container">
                <img
                  src={tool.image}
                  alt={tool.name}
                  style={{
                    width: idx === 2 ? "95px" : idx === 3 ? "145px" : "125px",
                    height: "auto",
                  }}
                />
              </div>

              <p className="tool-description">{tool.description}</p>
            </AnimatedBox>
          ))}
        </section>
      </div>

      <style jsx>{`
        .tools-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 36px;
          justify-content: center;
        }

        .tool-card {
          flex: 1 1 100%;
          border-radius: 16px;
          padding: 32px 18px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: linear-gradient(0deg, #715dda, #3edfd0);
          box-sizing: border-box;
        }

        .image-container {
          width: 160px;
          height: 65px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 20px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          margin-bottom: 16px;
          background-color: white;
        }

        .tool-description {
          font-size: 17px;
          color: white;
          line-height: 1.5;
        }

        @media (min-width: 640px) {
          .tool-card {
            flex: 0 1 calc(50% - 12px);
          }
        }

        @media (min-width: 1024px) {
          .tool-card {
            flex: 0 1 calc(33.333% - 16px);
          }
        }
      `}</style>
    </>
  );
};

export default ToolsSection;
